<aside
  *ngIf="notice as n"
  class="maintenance-banner maintenance-banner--{{ n.type }}"
  [attr.role]="n.type === 'critical' ? 'alert' : 'status'"
  [attr.aria-live]="n.type === 'critical' ? 'assertive' : 'polite'"
  data-testid="maintenance-banner"
>
  <div class="maintenance-banner__accent"></div>
  <div class="maintenance-banner__icon" aria-hidden="true">
    <svg
      width="22"
      height="22"
      viewBox="0 0 24 24"
      fill="none"
      stroke="currentColor"
      stroke-width="1.8"
      stroke-linecap="round"
      stroke-linejoin="round"
    >
      <path d="M10.4 4.2 2.5 18a2 2 0 0 0 1.7 3h15.6a2 2 0 0 0 1.7-3L13.6 4.2a1.8 1.8 0 0 0-3.2 0Z" />
      <path d="M12 9v4M12 17h.01" />
    </svg>
  </div>
  <div class="maintenance-banner__copy">
    <div class="maintenance-banner__heading">
      <p class="maintenance-banner__eyebrow">{{ n.eyebrow }}</p>
      <span class="maintenance-banner__window">{{ n.window }}</span>
    </div>
    <p class="maintenance-banner__title">{{ n.title }}</p>
    <p class="maintenance-banner__message">{{ n.message }}</p>
  </div>
  <button
    *ngIf="n.dismissible"
    type="button"
    class="maintenance-banner__dismiss"
    aria-label="Dismiss maintenance notice"
    data-testid="maintenance-banner-dismiss"
    (click)="dismiss()"
  >
    <svg
      width="18"
      height="18"
      viewBox="0 0 24 24"
      fill="none"
      stroke="currentColor"
      stroke-width="1.8"
      stroke-linecap="round"
      aria-hidden="true"
    >
      <path d="m6 6 12 12M18 6 6 18" />
    </svg>
  </button>
</aside>
